export enum PageMode {
    ADD = 'add',
    EDIT = 'edit'
}
